import React, { useState } from 'react';
import {
  createNewSupplierFirstStepSchema,
  createNewSupplierFourthStepSchema,
  createNewSupplierSchema,
  createNewSupplierSecondStepSchema,
  createNewSupplierThirdStepSchema,
} from '../supplierValidators';
import { RiArrowRightSLine } from 'react-icons/ri';
import FinanceDetails from './FinanceDetails';
import SupplierDetails from './SupplierDetails';
import Redirects from './Redirects';
import Review from './Review';
import LocationDetails from './LocationDetails';
import { useGlobalContext } from '../../../Contexts/GlobalContext';
import { useNavigate } from 'react-router-dom';
import MyStepper from '../../../components/MyStepper';
import { Button } from '../../../components/UiComponents/Ui';
import AddLocationModal from '../../../components/UiComponents/AddLocationModal';
import AddBankAccountModal from '../../../components/UiComponents/AddBankAccountModal';
import { formateZodError } from '../../../Utlils';
import SubmitButton from '../../../components/UiComponents/SubmitButton';
import { createNewSupplier } from '../../../Actions/supplierActions';
const defaultSupplierData = {
  companyCodes: [],
  globalRedirects: true,
  serverCallback: true,
  currency: { label: 'Indian Rupee', value: 'INR', symbol: '₹' },
};

const defaultBankAccount = {
  accountHolderName: '',
  bankName: '',
  accountNumber: '',
  bankType: 'savings',
  bankAddress: {
    street1: '',
    street2: '',
    city: '',
    state: { label: '', value: '' },
    postalCode: '',
    country: { label: '', value: '' },
  },
};

const SupplierForm = () => {
  const navigate = useNavigate();
  const { setSnackbar } = useGlobalContext();
  const [currentStep, setCurrentStep] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [supplierData, setSupplierData] = useState(defaultSupplierData);
  const [formErrors, setFormErrors] = useState({});
  const [editLocationModal, setEditLocationModal] = useState({
    open: false,
    index: 0,
  });
  const [addLocationModal, setAddLocationModal] = useState(false);
  const [locationData, setLocationData] = useState({});
  const [addBankAccountModal, setAddBankAccountModal] = useState(false);
  const [bankData, setBankData] = useState(defaultBankAccount);
  const [editBankAccountModal, setEditBankAccountModal] = useState({
    open: false,
    index: 0,
  });

  const handlePrev = () => setCurrentStep((s) => (s === 1 ? 1 : s - 1));

  const handleModalOpen = (edit = false, editIndex = 0) => {
    if (edit) setEditLocationModal({ open: true, index: editIndex });
    setAddLocationModal(true);
  };

  const handleCloseModal = () => {
    setAddLocationModal(false);
    setEditLocationModal({ open: false, index: 0 });
    setLocationData({});
  };

  const handleBankModalOpen = (edit = false, editIndex = 0) => {
    if (edit) setEditBankAccountModal({ open: true, index: editIndex });
    setAddBankAccountModal(true);
  };

  const handleBankCloseModal = () => {
    setAddBankAccountModal(false);
    setEditBankAccountModal({ open: false, index: 0 });
    setBankData(defaultBankAccount);
  };

  const handleRemoveBankAccount = (index) => {
    setSupplierData((prev) => ({
      ...prev,
      bankAccounts: prev.bankAccounts?.filter((_, i) => i !== index),
    }));
  };

  const stepsConfig = [
    {
      name: 'Supplier Details',
      helperName: 'STEP 1',
      Component: (
        <SupplierDetails
          supplierData={supplierData}
          setSupplierData={setSupplierData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
      ),
    },
    {
      name: 'Location',
      helperName: 'STEP 2',
      Component: (
        <LocationDetails
          setSupplierData={setSupplierData}
          handleModalOpen={handleModalOpen}
          supplierData={supplierData}
          setModalData={setLocationData}
          formErrors={formErrors}
        />
      ),
    },
    {
      name: 'Finance',
      helperName: 'STEP 3',
      Component: (
        <FinanceDetails
          supplierData={supplierData}
          setSupplierData={setSupplierData}
          setModalData={setBankData}
          handleRemoveBankAccount={handleRemoveBankAccount}
          formErrors={formErrors}
          handleBankModalOpen={handleBankModalOpen}
        />
      ),
    },
    {
      name: 'Redirect & Callbacks',
      helperName: 'STEP 4',
      Component: (
        <Redirects
          supplierData={supplierData}
          setSupplierData={setSupplierData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
      ),
    },
    {
      name: 'Review',
      helperName: 'STEP 5',
      Component: (
        <Review
          supplierData={supplierData}
          setSupplierData={setSupplierData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          setLocationModalData={setLocationData}
          handleLocationModalOpen={handleModalOpen}
          setBankAccountModalData={setBankData}
          handleBankModalOpen={handleBankModalOpen}
          handleRemoveBankAccount={handleRemoveBankAccount}
        />
      ),
    },
  ];

  const stepConfig = [
    { schema: createNewSupplierFirstStepSchema },
    { schema: createNewSupplierSecondStepSchema },
    { schema: createNewSupplierThirdStepSchema },
    { schema: createNewSupplierFourthStepSchema },
  ];

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (currentStep < stepsConfig.length) {
        const { schema } = stepConfig[currentStep - 1];
        const result = schema.safeParse(supplierData);
        console.log('result=>', result);

        if (result.success) {
          setSupplierData((prev) => ({ ...prev, ...result.data }));
          console.log(`setting current step to ${currentStep + 1}`);
          setCurrentStep((prev) => prev + 1);
          //   setFormErrors({});
        } else {
          console.log(
            'formateZodError=>',
            formateZodError(result.error.errors),
          );
          setFormErrors(formateZodError(result.error.errors));
        }
      } else {
        const result = createNewSupplierSchema.safeParse(supplierData);

        if (result.success) {
          const response = await createNewSupplier(result.data);
          console.log('response=>', response);

          if (!response?.error) {
            setSnackbar({
              open: true,
              msg: 'New Supplier Created Successfully!',
              severity: 'success',
            });

            navigate(`/suppliers`);
          } else {
            setSnackbar({
              open: true,
              msg: 'Internal Server Error! Please try again!',
              severity: 'error',
            });
          }
        } else {
          setFormErrors(formateZodError(result.error.errors));
          setCurrentStep(1);
        }
      }
    } catch (error) {
      setSnackbar({
        open: true,
        msg: 'Internal Server Error! Please try again!',
        severity: 'error',
      });
    }
  };
  console.log('supplierData=>', supplierData);
  console.log('formErrors=>', formErrors);

  return (
    <div>
      <form
        className="flex flex-col items-center justify-center"
        onSubmit={handleSubmit}
      >
        <div className="min-h-[90vh] w-[70%] py-6">
          <MyStepper
            stepsConfig={stepsConfig}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            isComplete={isComplete}
            setIsComplete={setIsComplete}
            position="vertical"
          />
        </div>

        <section className="sticky bottom-0 w-full border-t border-gray-200 bg-white px-8 py-[18px]">
          <div className="flex justify-end gap-2">
            {currentStep > 1 && (
              <Button variant="outlined" intent="default" onClick={handlePrev}>
                Back
              </Button>
            )}

            {currentStep === stepsConfig.length ? (
              <SubmitButton name="finish" />
            ) : (
              <Button
                type="submit"
                disabled={currentStep === 2 && !supplierData?.locations?.length}
                endIcon={<RiArrowRightSLine size={22} />}
              >
                Save and Continue
              </Button>
            )}
          </div>
        </section>
      </form>

      <AddLocationModal
        showModal={addLocationModal}
        setShowModal={setAddLocationModal}
        handleCloseModal={handleCloseModal}
        modalData={locationData}
        setModalData={setLocationData}
        setCustomerData={setSupplierData}
        edit={editLocationModal.open}
        ediIndex={editLocationModal.index}
      />
      <AddBankAccountModal
        showModal={addBankAccountModal}
        setShowModal={setAddBankAccountModal}
        handleCloseModal={handleBankCloseModal}
        modalData={bankData}
        setModalData={setBankData}
        setCustomerData={setSupplierData}
        edit={editBankAccountModal.open}
        ediIndex={editBankAccountModal.index}
      />
    </div>
  );
};

export default SupplierForm;
